'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'

export const SubMenuOptionWrapper = styled.div<{ menuItemsGap?: string }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  ${({ menuItemsGap }) => menuItemsGap && `gap: ${menuItemsGap}`}
`
